import { render, staticRenderFns } from "./AchContainer.vue?vue&type=template&id=1c56323a&"
import script from "./AchContainerVue.ts?vue&type=script&lang=ts&"
export * from "./AchContainerVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports